import { deserialize } from "deserialize-json-api";
import config from "../config";
import * as types from "./types";

function onRequestSaga(request, action) {
  if (action.type === types.LOGIN || action.meta?.noCredentails) {
    return request;
  }
  request.headers = {
    ...request.headers,
    Authorization: localStorage.getItem(config.accessTokenName)
  };
  return request;
}

function onSuccessSaga(response, action) {
  if (action.type === types.LOGIN) {
    localStorage.setItem(config.accessTokenName, response.headers.authorization);
  }
  if (action.type === types.LOGOUT) {
    localStorage.removeItem(config.accessTokenName);
  }
  if (!(action.meta && action.meta.noSerialize)) {
    return { ...response, data: deserialize(response.data, { transformKeys: "camelCase" }) };
  }
  return response;
}

function onErrorSaga(error) {
  // eslint-disable-next-line no-console
  console.error("ERROR", error);
  if (error.response.config.url !== "/login.json" && error.response.config.url !== "/users/me") {
    if (
      (error && error.response && error.response.status === 401) ||
      error.toString().match(/network error/i)
    ) {
      localStorage.removeItem(config.accessTokenName);
      window.location.href = "/";
    }
  }

  throw error;
}

function onAbortSaga() {}

export default {
  onRequest: onRequestSaga,
  onSuccess: onSuccessSaga,
  onError: onErrorSaga,
  onAbort: onAbortSaga
};
